import React from 'react';
import { isValidEmailFormat, getEmailSuggestion } from '../lib/emailValidation';

// Inline feedback shown under an email input: format error + "Did you mean ...?" suggestion.
export const EmailFieldHint = ({ value, onAccept, testIdPrefix = 'email' }) => {
  const v = (value || '').trim();
  if (!v) return null;

  const validFormat = isValidEmailFormat(v);
  if (!validFormat) {
    return (
      <p className="text-xs text-red-600 mt-1" data-testid={`${testIdPrefix}-format-error`}>
        Please enter a valid email address (e.g. name@gmail.com)
      </p>
    );
  }

  const suggestion = getEmailSuggestion(v);
  if (suggestion) {
    return (
      <p className="text-xs text-amber-600 mt-1" data-testid={`${testIdPrefix}-suggestion`}>
        Did you mean{' '}
        <button
          type="button"
          onClick={() => onAccept(suggestion)}
          className="font-semibold underline hover:text-amber-700"
          data-testid={`${testIdPrefix}-suggestion-accept`}
        >
          {suggestion}
        </button>
        ?
      </p>
    );
  }

  return null;
};

export default EmailFieldHint;
